import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react'; // 🔹 ADIÇÃO: Importa useState e useCallback
import { useAuth } from './AuthContext';
import { requestNotificationPermissionAndSaveToken } from '../services/notificationService';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const { user, isAuthenticated, vinculoSelecionado } = useAuth();
  const permissionRequestedRef = useRef(false);

  // 🔹 ADIÇÃO: Estado para controlar o toast
  const [toast, setToast] = useState(null);

  useEffect(() => {
    // console.log("[Debug Notificação] Verificando estado de autenticação...", { isAuthenticated, vinculoSelecionado });

    const subscribeToNotifications = async () => {
      // Espera o Service Worker estar pronto antes de prosseguir
      await navigator.serviceWorker.ready;

      if (isAuthenticated && vinculoSelecionado && !permissionRequestedRef.current) {
        if (!user) {
          // console.warn("[Debug Notificação] Autenticado, mas o objeto 'user' não foi encontrado no AuthContext.");
          return;
        }

        // console.log(`[Debug Notificação] Usuário autenticado e vínculo selecionado (CPF: ${user.cpf}, Vínculo: ${vinculoSelecionado.matricula}). Solicitando permissão...`);
        
        await requestNotificationPermissionAndSaveToken(user); // Passa o objeto user
        permissionRequestedRef.current = true;
      } else {
        /*
        console.log("[Debug Notificação] Lógica de notificação ignorada. Motivo:", {
          isAuthenticated: isAuthenticated ?? false,
          vinculoSelecionado: !!vinculoSelecionado,
          permissionAlreadyRequested: permissionRequestedRef.current,
        });
        */
      }
    };

    // Chama a função assíncrona dentro do useEffect
    subscribeToNotifications();

  }, [isAuthenticated, vinculoSelecionado, user]);

  // 🔹 ADIÇÃO: Funções para mostrar e esconder o toast
  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  // 🔹 ADIÇÃO: Objeto de valor que inclui as funções do toast
  const value = {
    toast,
    showToast,
    hideToast
  };

  return (
    // 🔹 ALTERAÇÃO: Passa o objeto 'value' completo em vez de um objeto vazio
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};